<div class="demo-components-container">
    <router-outlet></router-outlet>
</div>